import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { modelQuery } from '@/features/ml/models/model-api';
import { ModelDetailPage } from '@/features/ml/models/model-detail-page';
import { isModelTab, type ModelTab } from '@/features/ml/models/model-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un modèle du registre. L'onglet actif vit dans l'URL (`?tab=summary`). */
export const Route = createFileRoute('/$tenant/models/$modelId/')({
  validateSearch: (search: Record<string, unknown>): { tab: ModelTab } => ({
    tab: isModelTab(search['tab']) ? search['tab'] : 'versions',
  }),
  component: ModelRoute,
});

function ModelRoute() {
  const { tenant, modelId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const model = useQuery(modelQuery(tenant, modelId));
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="models"
      crumbs={[{ label: t('nav.items.models') }, { label: model.data?.name ?? modelId, mono: true }]}
    >
      <ModelDetailPage
        tenantId={tenant}
        modelId={modelId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
